// Front/src/utils/generateScaleTypeJson.js

// Generate JSON Data for a new scale type
export const generateScaleTypeJson = (formData, userId) => {
    const max = parseFloat(formData.maxValue);
    const min = parseFloat(formData.minValue);
    const e = parseFloat(formData.eValue);
    const d = parseFloat(formData.dValue);
    const n = parseInt(formData.nValue);

    // Calculate EtoD ratio
    let etoDRatio;
    const ratio = e / d;  
    if (ratio === 1) {
      etoDRatio = "Equal";
    } else if (ratio === 2) {
      etoDRatio = "TwoTimes";
    } else if (ratio === 10) {
      etoDRatio = "TenTimes";
    } else {
      etoDRatio = "Unknown";
    }

    return {
        Id: formData.catalogNumber,
        Model: formData.model,
        Manufacturer: formData.manufacturer,
        Standard: formData.standard,
        Notes: formData.notes,
        ScaleAccuracy: {
            WeightUnits: formData.weightUnits,
            Max: max,
            Min: min,
            MaxInGrams: formData.weightUnits === "kg" ? max * 1000 : max,
            MinInGrams: formData.weightUnits === "kg" ? min * 1000 : min,
            EInGrams: formData.weightUnits === "kg" ? e * 1000 : e,
            E: e,
            D: d,
            N: n,
            EtoDRatio: etoDRatio,
            AccuracyClass: ["ONE", "TWO", "THREE", "FOUR"][formData.accuracyClass - 1] || ""
        },
        AddedBy: {
            ApiUserId: userId,
            Date: new Date().toISOString()
        },
        IsActive: true
    };
};
